// Port of api/fuel/app/classes/filter/search/games/sorts/query/game/votes.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'votes.bgg',
	post: false,
	require: function(config, filter) { return sorted('votes.bgg', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('g.game_rating_count', sortReverse('votes.bgg', filter), sortPriority('votes.bgg', filter))
	}
}
